import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { CSSTransition } from 'react-transition-group'
import { bem, canUseDom } from '@argos/utils'

import { Creators as FrameCreators } from '../Frame'
import { Window, Launcher } from '../containers'

const cn = bem({ prefix: 'lc-', block: 'frame' })

class Frame extends React.Component {
  static propTypes = {
    /* props passed via host app */
    brand: PropTypes.string,
    department: PropTypes.string,
    hidden: PropTypes.bool,
    minimized: PropTypes.bool,
    onEnd: PropTypes.func,
    onMinimized: PropTypes.func,
    reset: PropTypes.bool,
    webSocketUrl: PropTypes.string,

    /* props injected via redux state */
    chatStartTime: PropTypes.string,
    windowIsActive: PropTypes.bool,
    windowIsMinimized: PropTypes.bool,
    onLaunchChat: PropTypes.func,
    onToggleActive: PropTypes.func,
    onToggleMinimized: PropTypes.func,
  }

  static defaultProps = {
    hidden: true,
    minimized: false,
    reset: false,
    windowIsActive: true,
    windowIsMinimized: false,
    onMinimized: () => {},
    onEnd: () => {},
    onLaunchChat: () => {},
  }

  componentDidMount() {
    if (!this.props.hidden && !this.props.minimized) {
      this.props.onLaunchChat()
    }

    if (canUseDom()) window.addEventListener('keydown', this.handleKeyboardClose)
  }

  componentWillReceiveProps(nextProps) {
    /* tell the host application the chat is minimized */
    if (nextProps.windowIsMinimized) this.props.onMinimized()

    /* tell the host application the chat has ended */
    if (!nextProps.windowIsActive) this.props.onEnd()

    /* let the host app re-launch chat when chat has ended */
    if (!this.props.windowIsActive && nextProps.reset) this.props.onLaunchChat()

    /* let the host app maximise chat when chat is minimized */
    if (this.props.windowIsMinimized && !nextProps.minimized) {
      this.props.onToggleMinimized(false)
    }

    /* focus the launcher when chat gets minimized */
    if (!this.props.windowIsMinimized && nextProps.windowIsMinimized) {
      this.launcherRef.focus()
    }
  }

  componentWillUnmount() {
    if (canUseDom()) window.removeEventListener('keydown', this.handleKeyboardClose)
  }

  handleKeyboardClose = (evt) => {
    const { windowIsActive, onToggleActive } = this.props

    if (evt.keyCode === 27 && windowIsActive) {
      onToggleActive(false)
    }
  }

  render() {
    const {
      brand,
      chatStartTime,
      department,
      hidden,
      onSetChatStartTime,
      webSocketUrl,
      windowIsActive,
      windowIsMinimized,
    } = this.props

    if (hidden) {
      return null
    }

    if (!chatStartTime) onSetChatStartTime()
    return (
      <section data-test={cn()} className={cn()}>
        <Launcher
          launcherRef={(ref) => {
            this.launcherRef = ref
          }}
        />

        <CSSTransition in={windowIsActive && !windowIsMinimized} timeout={200} classNames='fadeSlideY' unmountOnExit>
          {() => <Window {...{ brand, department, webSocketUrl }} />}
        </CSSTransition>
      </section>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  onLaunchChat: () => dispatch(FrameCreators.launchChat()),
  onSetChatStartTime: () => dispatch(FrameCreators.setChatStartTime()),
  onToggleActive: (toggled) => dispatch(FrameCreators.toggleActive(toggled)),
  onToggleMinimized: (toggled) => dispatch(FrameCreators.toggleMinimized(toggled)),
})

const mapStateToProps = (state) => ({
  chatStartTime: state.Frame.chatStartTime,
  windowIsActive: state.Frame.windowIsActive,
  windowIsMinimized: state.Frame.windowIsMinimized,
})

export { Frame }

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Frame)
